<template>
    <div class="job-profile">
        <Navbar />
        <div class="mt-5 pt-5">
            <div class="px-0 mx-3 px-sm-2 mx-sm-3 px-md-3 mx-md-3 px-lg-4 mx-lg-4">
                <div class="text-left mt-3 ml-5 mb-4">
                    <a-icon class="mr-1" type="arrow-left" /> <span class="go-back">Go Back</span>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-9 px-md-5">
                        <div class="row">
                            <div class="col-8">
                                <h3 class="font-weight-bolder kova-text text-left">Customise Wordpress Login</h3>
                            </div>
                            <div class="col-4">
                                <h3 class="kova-text font-weight-bolder text-left">$20 - $169</h3>
                            </div>
                        </div>
                        <div>
                            <div class="bg-light border add-rounded p-4 mt-4">
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-9">
                                        <div class="row pl-3">
                                            <div>
                                                <h4 class="font-weight-bolder text-left">Customise Wordpress Login</h4>
                                            </div>
                                            <div class="id ml-3 text-white">ID: 23498</div>
                                        </div>
                                        <h4 class="text-left mt-3">Brief</h4>
                                        <p class="text-left">
                                            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
                                            eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
                                            voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet
                                            clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit
                                            amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
                                            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed
                                            diam
                                        </p>
                                        <h4 class="text-left mt-3">Skills Required</h4>
                                        <div class="text-left d-flex flex-wrap">
                                            <span
                                                class="bg-skills px-3 py-2 mr-3 mb-3 rounded"
                                                v-for="skill in skills"
                                                :key="skill"
                                            >
                                                {{ skill }}</span
                                            >
                                        </div>
                                        <h4 class="text-left mt-3">Budgets</h4>
                                        <div class="row pl-3">
                                            <div><h2 class="text-left font-weight-bolder">$1,340 - $3,000 .</h2></div>
                                            <div class="ml-3 mt-2 incr-font-1">$20.00/hr</div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-3">
                                        <div class="text-right font-weight-bolder">
                                            <font-awesome-icon icon="clock" class="mr-2" />Bidding is still on
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr class="my-4" />
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-3 px-0 pt-lg-4 mt-lg-5 mb-5">
                        <div class="pt-2 mt-1"></div>
                        <div class="bg-light border add-rounded mt-5 px-3 pb-3">
                            <h4 class="font-weight-bolder mt-4 text-left">Posted By</h4>
                            <div class="row">
                                <div class="col-4 col-md-5 col-lg-4">
                                    <img
                                        src="../assets/kovatek/Mask Group 46.svg"
                                        alt=""
                                        class="rounded-circle img-height"
                                    />
                                </div>
                                <div class="col-8 col-md-7 col-lg-8 pl-3">
                                    <h3 class="font-weight-bolder kova-text text-left employer-name">Johnson. K</h3>
                                    <h6 class="font-weight-bolder text-left">7 jobs posted</h6>
                                    <div class="text-left">
                                        <span class="ctrl-size"
                                            ><a-icon class="icon-env mb-1" type="environment" /> Nigeria
                                        </span>
                                        <h6 class="font-weight-bolder text-left">$56, 000 spent</h6>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-4 add-rounded bg-kovatek p-4">
                                <h5 class="font-weight-bolder text-left text-white">Verifications</h5>
                                <div class="row">
                                    <div class="col-4 pl-3 text-left">
                                        <a-icon class="text-white icon-env mb-2" type="credit-card" /> <br />
                                    </div>
                                    <div class="col-8 text-right text-white">
                                        <p class="">Interviewing: 4</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-4 pl-3 text-left">
                                        <a-icon class="text-white icon-env mb-2 mt-1" type="message" /><br />
                                    </div>
                                    <div class="col-8 text-right text-white">
                                        <p class="">Payment Method</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-4 pl-3 text-left">
                                        <a-icon class="text-white icon-env mb-2 mt-1" type="mail" /><br />
                                    </div>
                                    <div class="col-8 text-right text-white">
                                        <p class="">Email</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-4 pl-3 text-left">
                                        <a-icon class="text-white icon-env mb-2 mt-1" type="phone" /><br />
                                    </div>
                                    <div class="col-8 text-right text-white">
                                        <p class="">Phone Number</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footers />
    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footers from '@/components/Footer.vue';

export default {
    name: 'job-details',
    components: {
        Navbar,
        Footers,
    },
};
</script>

<style scoped>
.kova-text {
    color: #20409a;
}
.add-rounded {
    border-radius: 10px;
}
.incr-font-1 {
    font-size: 20px;
    font-style: italic;
}
.bg-skills {
    background-color: #dde;
}
.bg-kovatek {
    background-color: #20409a;
}
.id {
    width: 100px;
    height: 20px;
    background-color: #7cd192;
    border-radius: 5px;
}
.img-height {
    width: 90px;
    height: 90px;
}

@media screen and (min-width: 992px) and (max-width: 1325px) {
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
    .employer-name {
        font-size: 18px;
    }
    .img-height {
        width: 70px;
        height: 70px;
    }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
}

@media screen and (max-width: 767px) {
    .float-text {
        display: flex;
        justify-content: space-between;
        padding-right: 50px;
    }
    .float-text h6 {
        float: left;
    }
}
</style>
